var map = {
	"./ArtCanvas.vue": [
		"b79f",
		"chunk-7ddfd831",
		"chunk-5cec5bd8",
		"chunk-2d0df2d0",
		"chunk-47b6e7de"
	],
	"./ChurchCanvas.vue": [
		"8a4b",
		"chunk-7ddfd831",
		"chunk-143dd5e8"
	],
	"./CityCanvas.vue": [
		"d8f9",
		"chunk-ff3d2f84",
		"chunk-7ddfd831",
		"chunk-5cec5bd8",
		"chunk-51e826ed"
	],
	"./CodeBuildingCanvas.vue": [
		"a292",
		"chunk-7ddfd831",
		"chunk-4206c080"
	],
	"./DanceCanvas.vue": [
		"b08b",
		"chunk-7ddfd831",
		"chunk-238b3852"
	],
	"./GamePlayCanvas.vue": [
		"da37",
		"chunk-7ddfd831",
		"chunk-5cec5bd8",
		"chunk-2d0df2d0",
		"chunk-4be96319"
	],
	"./IsoCityCanvas.vue": [
		"bb6a",
		"chunk-ff3d2f84",
		"chunk-7ddfd831",
		"chunk-0fb7f8e8"
	],
	"./LandingCanvas.vue": [
		"29cc",
		"chunk-7ddfd831",
		"chunk-1310a359"
	],
	"./MenuCanvas.vue": [
		"1393",
		"chunk-7ddfd831",
		"chunk-42701464"
	],
	"./ThankYouCanvas.vue": [
		"5087",
		"chunk-7ddfd831",
		"chunk-6bb95b20"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4805";
module.exports = webpackAsyncContext;